import React from 'react'
import Header from '../../components/Header/'
import Title from '../../components/Title'
import Footer from '../../components/Footer'
import useT from '../../components/Traduction'
import ButtonLink from '../../components/ButtonLink'
import FormatsBySupplierComponent from '../../components/FormatsBySupplier/formats-by-supplier'

function FormatsBySupplier({ userGroup, dataProject }) {
    const t = useT()
    return (
        <>
            <div className="min-height">
                <Title titleName={t('Formats_by_supplier')} />
                <Header link="/" titleHeader={t('Formats_by_supplier')} linkText={t('Back')} />
                <ButtonLink link="/" 
                    linkText={t("Back")} 
                    className="button-small-back"
                />
                <FormatsBySupplierComponent userGroup={userGroup} dataProject={dataProject}/>
            </div>
            <Footer />
        </>
    )
  }

export default FormatsBySupplier